import "../SupportTable/SupportTable.css";

export type ValorSolicitadoItem = {
  solicitacao: string;
  data: string;
  valor: string;
};

export interface ValoresJaSolicitadosTableProps {
  itens?: ValorSolicitadoItem[];
  total?: string;
  valorLiquidoApoio?: string;
  hideLiquidoApoio?: boolean;
}

const ValoresJaSolicitadosTable = ({
  itens = [],
  total = "R$ 0,00",
  valorLiquidoApoio = "R$ 0,00",
  hideLiquidoApoio = false,
}: ValoresJaSolicitadosTableProps) => (
  <div>
    <div className="support-valores-liberados-title">VALORES JÁ SOLICITADOS</div>
    <table className="support-valores-liberados-table">
      <thead>
        <tr>
          <th>SOLICITAÇÃO</th>
          <th>DATA DA SOLICITAÇÃO</th>
          <th>VALOR APOIADO</th>
        </tr>
      </thead>
      <tbody>
        {itens.map((item, idx) => (
          <tr key={idx}>
            <td>{item.solicitacao}</td>
            <td>{item.data}</td>
            <td>{item.valor}</td>
          </tr>
        ))}
        {itens.length === 0 ? (
          <tr>
            <td colSpan={3}>&nbsp;</td>
          </tr>
        ) : null}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={2} className="text-end">
            TOTAL DOS VALORES SOLICITADOS
          </td>
          <td>{total}</td>
        </tr>
      </tfoot>
    </table>
    <div className="support-valores-liberados-instrucao">
      *Não realizar deduções em parcela de bônus extra
    </div>

    {!hideLiquidoApoio && (
      <div className="support-bloco-azul">
        <div className="label">TOTAL LÍQUIDO DO APOIO</div>
        <div className="valor">{valorLiquidoApoio}</div>
      </div>
    )}
  </div>
);

export default ValoresJaSolicitadosTable;
